module.exports = __webpack_public_path__ + "img/banner2.82966c3a.png";